import { useDispatch, useSelector } from "react-redux";
import {
  openLocalGameModal,
  closeLocalGameModal,
} from "@/Poker/redux/slices/gameTableSlice";
import { PLAYER_STATS } from "@/Poker/data/Constants";

export default function usePlayerStats(tempTableId) {
  const dispatch = useDispatch();
  const modalType = useSelector(
    (state) => state.gameTable.games[tempTableId].gameModal.type
  );
  const modalStatus = useSelector(
    (state) => state.gameTable.games[tempTableId].gameModal.visible
  );

  const openPlayerStats = () => {
    dispatch(
      openLocalGameModal({ tempTableId: tempTableId, type: PLAYER_STATS })
    );
  };

  const closePlayerStats = () => {
    dispatch(
      closeLocalGameModal({
        tempTableId: tempTableId,
      })
    );
  };

  return {
    modalType,
    modalStatus,
    openPlayerStats,
    closePlayerStats,
  };
}
